import { render, staticRenderFns } from "./Man1Create.vue?vue&type=template&id=6a724303&"
import script from "./js/man1Create.js?vue&type=script&lang=js&"
export * from "./js/man1Create.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports